import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  Input
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Entry } from 'contentful';

import { LocalizationService } from '../../services/localization/localization.service';
import { GlobalContentService } from '../../services/global-content/global-content.service';
import { Country } from '../../interfaces/country';

@Component({
  selector: 'app-select-country',
  templateUrl: './select-country.component.html',
  styleUrls: ['./select-country.component.scss']
})
export class SelectCountryComponent implements OnInit, OnDestroy {
  // TODO: Make this Component dummy component
  public content: Entry<any> | undefined;
  public selectedCountryCode: string | undefined;
  public countries: Array<Country>;
  public globalContent: Entry<any>;
  @Input() public defaultCountry: Country;
  @Input() public labelForId: string;
  @Output() public changed = new EventEmitter<any>();
  private subscriptions: Array<Subscription> = [];

  constructor(
    private localizationService: LocalizationService,
    private globalContentService: GlobalContentService
  ) {}

  ngOnInit() {
    if (this.defaultCountry) {
      this.selectedCountryCode = this.defaultCountry.country_code;
    }

    this.subscriptions.push(
      this.globalContentService.getGlobalContent().subscribe(entry => {
        this.globalContent = entry;
        this.countries = this.getCountries();
      })
    );
  }

  findCountryByCode(countryCode: string) {
    const foundCountry = this.countries.filter(country => {
      return country.country_code === countryCode;
    });
    return foundCountry.length > 0 ? foundCountry[0] : false;
  }

  countryChanged() {
    const country = this.findCountryByCode(this.selectedCountryCode);
    this.changed.emit(country);
  }

  getCountries() {
    if (this.globalContent) {
      return this.globalContent.fields.countries
        .map((country: Country) => {
          if (
            this.localizationService.getLocale().value === 'fi' &&
            country.country_fi
          ) {
            country.label = country.country_fi;
          } else {
            country.label = country.country;
          }
          return country;
        })
        .sort((a: Country, b: Country) => {
          return ('' + a.country).localeCompare(b.country);
        });
    } else {
      return [];
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }
}
